export var EStickyType;
(function (EStickyType) {
  EStickyType["Simple"] = "simple";
  EStickyType["Old"] = "old";
  EStickyType["Modern"] = "modern";
})(EStickyType || (EStickyType = {}));